import { lazy, Suspense } from 'react';
import { useToastStore } from '@/lib/toast';

// Radix Toast is its own chunk: nobody pays for it until the first toast is shown.
const ToastHost = lazy(() => import('./ToastHost'));

/**
 * Mount once per app frame. Renders nothing until `toast()` is called for the first time, then loads
 * the host (the polite/assertive live regions live there).
 */
export function Toaster() {
  const everShown = useToastStore((state) => state.everShown);
  if (!everShown) return null;
  return (
    <Suspense fallback={null}>
      <ToastHost />
    </Suspense>
  );
}
